/* eslint camelcase: ["error", {allow: ["htmlrichtext_UpdateConfig"]}] */
'use strict';

/**
* @ngdoc service
* @name tcApp.WebsysHtmlRichTextLegacyScope
* @description
* Contains systemUI equivalents for legacy functions originally defined in websys.htmlrichtext.js
*
*/
angular.module('tc.legacyScope').factory('WebsysHtmlRichTextLegacyScope', function($timeout, $window, $log,
									LegacyScopeSearchService, LegacyScopeUtilsService, GlobalService, ElementStateService) {

	/* eslint no-unused-vars:0 */
	return function($scope) {

		var emptyFunction = function() {
		};

		var websysHtmlrichtextGetEditorDocument = function(obj) {
			return obj;
		};

		var websysHtmlrichtextSetHtml = function(obj, value) {
			LegacyScopeUtilsService.runOnEditorReady($scope, obj, function setValueOnEditorReady(editor) {
				// Timeout due to issue with multiple subsequent setData calls:
				// https://github.com/ckeditor/ckeditor4/issues/3669
				$timeout(function() {
					editor.setData(value);
				}, 300);
			});
		};

		var websysIsHTMLRichText = function(obj) {
			if (!obj) return false;
			return (obj.displayType === 'HRT');
		};

		// not implemented - validation done on server side
		var websysHtmlrichtextTidyHTML = function() {
			return;
		};

		var websysHtmlrichtextReplaceSpelling = function(HRT, oldval, newval, lastIndex, all, ignore) {
			var match = new RegExp('\\b' + oldval + '\\b','g');

			match.lastIndex = lastIndex;

			if (all == 1) {
				if (angular.isUndefined(CKEDITOR)) return match.lastIndex;
				var editor = CKEDITOR.instances[HRT];
				var text = editor.getData();
				var replacedMatch = {};
				do {
					replacedMatch = getReplacedMatch(text, newval, RegExp, match, ignore);
					if (replacedMatch.replacedText !== '') {
						text = replacedMatch.replacedText;
					}
				} while (replacedMatch.arr !== null);

				if (ignore != 1) {
					editor.setData(text);
				}
			} else {
				websysHtmlrichtextDoReplace(HRT, newval, lastIndex, RegExp, match, ignore);
			}

			return match.lastIndex;
		};

		var websysHtmlrichtextDoReplace = function(HRT, newval, lastIndex, RegExp, match, ignore) {
			if (angular.isUndefined(CKEDITOR)) return null;

			var editor = CKEDITOR.instances[HRT];
			var text = editor.getData();

			var replacedMatch = getReplacedMatch(text, newval, RegExp, match, ignore);
			if (replacedMatch.replacedText !== '') {
				editor.setData(replacedMatch.replacedText);
			}

			return replacedMatch.arr;
		};

		var getReplacedMatch = function(text, newval, RegExp, match, ignore) {
			var replacedMatch = {
				arr: match.exec(text),
				replacedText: '',
			};

			if (replacedMatch.arr === null) return replacedMatch;
			while (RegExp.rightContext.indexOf('>') < RegExp.rightContext.indexOf('<')) {
				replacedMatch.arr = match.exec(text);
				if (replacedMatch.arr === null) return replacedMatch;
			}

			if (ignore != 1) {
				replacedMatch.replacedText = RegExp.leftContext + newval + RegExp.rightContext;
			}

			return replacedMatch;
		};

		var websysHtmlrichtextInsertImage = function(HRT, cmp, ID) {
			var args = [GlobalService.serverMethods[0], 'websys.SYSTEM', '', 'RichTextGetDocument', cmp, ID];
			var src = $window.cspHttpServerMethod.apply(this, args);

			if (src.substring(0, 1) != '<') {
				src = '<img src=\'' + src + '\'>';
			}

			websysHtmlrichtextInsertHTML(HRT, src);
		};

		// only intended for internal use by the trakcareimage plugin
		var websysHtmlrichtextInsertImageOnReload = function(args) {
			if (!angular.isString(args) || (args === '')) return;
			var [HRT, imageCompName, ID, compName] = args.split('^');
			LegacyScopeUtilsService.runOnEditorReady($scope, HRT, function(editor) {
				var bookmarkString = ElementStateService.get(HRT + '-selection');
				if (angular.isDefined(bookmarkString) && (bookmarkString !== '')) {
					ElementStateService.removeKey(HRT + '-selection');

					// if there is a saved bookmark, attempt to restore selection
					try {
						var bookmark = angular.fromJson(bookmarkString);
						var range = editor.getSelection().getRanges()[0];
						range.moveToBookmark(bookmark);
						range.select();
					} catch (ex) {
						$log.error(ex);
					}
				}
				websysHtmlrichtextInsertImage(HRT, imageCompName, ID);
			}, compName);
		};

		// only intended for internal use by the trakcareimage plugin
		var websysHtmlrichtextReturnImage = function(HRT, compName, ID) {
			var RTFComponent = $scope.websys_getValue('RTFComponent', 'HtmlRichText.AddImage.Composite');
			$scope.websys_setReturnValue([HRT, compName, ID, RTFComponent].join('^'));
			$scope.websys_open('/CloseReload');
		};

		var websysHtmlrichtextInsertHTML = function(HRT, html) {
			if (angular.isUndefined(CKEDITOR)) return;
			var editor = CKEDITOR.instances[HRT];

			if (editor) {
				if (html.substring(0, 6) == '<EMBED') {
					var div = editor.document.createElement('div');
					div.setHtml(html);
					editor.insertElement(div);
				} else {
					editor.insertHtml(html);
				}
			}
		};

		var setStateForHRT = function(item, disabled) {
			if (item) {
				item.disabled = disabled;
				LegacyScopeUtilsService.runOnEditorReady($scope, item.id, function disableOnEditorReady(editor) {
					editor.setReadOnly(disabled);
				});
			}
		};

		var DisableHRT = function(item) {
			if (!angular.isObject(item)) {
				$log.warn('DisableHRT: Item object not passed');
				return;
			}
			setStateForHRT(item, true);
		};

		var EnableHRT = function(item) {
			if (!angular.isObject(item)) {
				$log.warn('EnableHRT: Item object not passed');
				return;
			}
			setStateForHRT(item, false);
		};

		// Wrapper function to set the htmlrichtext_UpdateConfig function in global Window scope
		// This function is to be used ny Region/Site to override some ckEditor config
		// and should not be used by core development
		var websysHtmlrichtextSetCustomConfigFunc = function(configFn) {
			if (!angular.isFunction(configFn)) {
				$log.warn('Invalid function to override htmlrichtext_UpdateConfig function');
			} else {
				if (!(configFn.length == 1)) {
					$log.warn('Invalid function to override htmlrichtext_UpdateConfig function, need to have 1 parameter');
				} else {
					$window.htmlrichtext_UpdateConfig = configFn;
				}
			}
		};

		// Return all the functions in an object
		var websysHtmlRichTextFunctions = {
			'websys_htmlrichtext_getEditorDocument': websysHtmlrichtextGetEditorDocument,
			'websys_htmlrichtext_setHtml': websysHtmlrichtextSetHtml,
			'websys_isHTMLRichText': websysIsHTMLRichText,
			'websys_htmlrichtext_TidyHTML': websysHtmlrichtextTidyHTML,
			'websys_htmlrichtext_ReplaceSpelling': websysHtmlrichtextReplaceSpelling,
			'websys_htmlrichtext_DoReplace': websysHtmlrichtextDoReplace,
			'websys_htmlrichtext_InsertImage': websysHtmlrichtextInsertImage,
			'websys_htmlrichtext_InsertImageOnReload': websysHtmlrichtextInsertImageOnReload,
			'websys_htmlrichtext_ReturnImage': websysHtmlrichtextReturnImage,
			'websys_htmlrichtext_InsertHTML': websysHtmlrichtextInsertHTML,
			'websys_htmlrichtext_setCustomConfigFunc': websysHtmlrichtextSetCustomConfigFunc,
			'DisableHRT': DisableHRT,
			'EnableHRT': EnableHRT
		};

		return websysHtmlRichTextFunctions;
	};
});
